import { WorkplaceFields } from "../../../api/graphql/workplaces";

// this function only returns true if room or desk is licensed and has calendarId and calendarProviderId
// and other workplaces

export const isValidWorkplace = (
  workplace: WorkplaceFields,
  bookingEnabled?: {
    roomBookingEnabled?: boolean;
    deskBookingEnabled?: boolean;
  }
) => {
  if (workplace.__typename === "Wayfinder") {
    return false;
  }

  if (!["Room", "Desk"].includes(workplace.__typename)) {
    return true;
  }

  if (workplace.__typename === "Room" && !bookingEnabled?.roomBookingEnabled) {
    return false;
  }

  if (workplace.__typename === "Desk" && !bookingEnabled?.deskBookingEnabled) {
    return false;
  }

  if (!workplace.licensed) {
    return false;
  }

  if (
    workplace.__typename === "Room" &&
    (!workplace.calendarId?.length || !workplace.calendarProviderId?.length)
  ) {
    return false;
  }

  return true;
};
